export const initialState = {
  resultUpload: {
    result: [],
    status: ' ERROR',
    totalCount: 0,
    files: null,
    fileName: '',
  },
}
